import { CtaForm } from '@pairy/sheard/types';

import MessageBoxLayer from '../../@common/Layer/MessageBoxLayer';
import EmbedLayer from '../../@common/Layer/EmbedLayer';
import DesktopHyperLinkLayer from '../../@common/Layer/HyperLinkLayer/Desktop';
import { EmbedItemType, MessageBoxItemType } from '../../PdfViewer/index.types';
import { V2PageType } from '../index.types';

interface Props {
  pageData: V2PageType;
  renderedWidth: number;
  renderedHeight: number;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  ctaForm?: CtaForm;
  isFormSubmitted?: boolean;
  /* 가림막 처리된 페이지 여부 — 임베드가 가려진 콘텐츠 위로 노출되지 않도록 한다 */
  isBlind?: boolean;
  /* 모바일에서는 메세지박스를 작은 변형으로 렌더한다 */
  isMobile?: boolean;
}

/**
 * 페이지 박스(정확히 렌더된 페이지 크기의 relative 컨테이너) 내부에서
 * 메세지박스/하이퍼링크를 렌더한다. 페이지 박스 기준이므로 margin은 0이다.
 */
const PageAnnotations = ({
  pageData,
  renderedWidth,
  renderedHeight,
  messageBoxItems,
  embedItems,
  ctaForm,
  isFormSubmitted,
  isBlind = false,
  isMobile = false,
}: Props) => {
  const resizedImageSize = {
    width: renderedWidth,
    height: renderedHeight,
    widthRatio: renderedWidth / pageData.originalWidth,
    heightRatio: renderedHeight / pageData.originalHeight,
    xMargin: 0,
    yMargin: 0,
  };

  const blindMode = ctaForm?.blind;

  const getFormNotSubmitPage = (moveTargetPage: number) => {
    if (
      !isFormSubmitted &&
      blindMode === 'startFrom' &&
      ctaForm?.page &&
      moveTargetPage >= ctaForm.page
    ) {
      return ctaForm.page;
    }
    return null;
  };

  /**
   * 가림막(startFrom)이 활성인 미제출 양식 페이지 — 가림이 해제되기 전까지
   * 재생(자동재생 포함)하지 않는다. blind가 'none'이면 페이지가 가려지지 않으므로
   * 임베드도 정상 동작해야 한다.
   */
  const isFormGatePage = Boolean(
    ctaForm &&
      blindMode === 'startFrom' &&
      !isFormSubmitted &&
      pageData.page === ctaForm.page,
  );

  return (
    <>
      <EmbedLayer
        page={pageData.page}
        resizedImageSize={resizedImageSize}
        embedItems={embedItems}
        isCovered={isBlind || isFormGatePage}
      />
      {/* 가림 페이지에서는 상호작용 요소(메시지박스/링크)를 노출하지 않는다 */}
      {!isBlind && (
        <>
          <MessageBoxLayer
            page={pageData.page}
            resizedImageSize={resizedImageSize}
            messageBoxItems={messageBoxItems}
            getFormNotSubmitPage={ctaForm ? getFormNotSubmitPage : undefined}
            size={isMobile ? 'sm' : 'default'}
          />
          <DesktopHyperLinkLayer
            hyperlinkList={pageData.hyperlink ?? []}
            resizedImageSize={resizedImageSize}
            isPreview={false}
            getFormNotSubmitPage={ctaForm ? getFormNotSubmitPage : undefined}
          />
        </>
      )}
    </>
  );
};

export default PageAnnotations;
